// Development environment configuration
const env = {
  API_URL: 'http://localhost:8004',
  FIREBASE_FUNCTIONS_URL: 'http://localhost:5001/fixmate-ai-mvp/us-central1/api'
};

export default env;
